/**
 * @generated SignedSource<<a82213042302f5918595937069c17a0a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CompetitionCardFragment$data = {
  readonly host: {
    readonly " $fragmentSpreads": FragmentRefs<"ActivityCardHostFragment">;
  };
  readonly id: string;
  readonly membership: {
    readonly entity: {
      readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
    };
    readonly id: string;
  } | null | undefined;
  readonly shortDescription: string;
  readonly slug: string;
  readonly thumbnail: Url | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityCardTagListFragment" | "CompetitionCardFooterFragment">;
  readonly " $fragmentType": "CompetitionCardFragment";
};
export type CompetitionCardFragment$key = {
  readonly " $data"?: CompetitionCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionCardFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionMembership",
      "kind": "LinkedField",
      "name": "membership",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "thumbnail",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "EntityProfilePicFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityCardHostFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ActivityCardTagListFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompetitionCardFooterFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "9fabb2cc060b9ebd06792cc9a539cc19";

export default node;
